export default function AboutMe() {
    return (
        <section className="aboutMeContainer" id="aboutMe">
            <div className="aboutme_text">
                <div className="aboutme_title">
                    <h1>About Me</h1>
                </div>
                <div className="aboutme_body">
                    <p>
                        I’m currently a Waterloo Engineering Student (allegedly). My experiences ranges around
                        automotive, industrial, hardware, robotics, AI, and much, much more.
                    </p>
                    <p>
                        My main goals right now are personal exploration and optimizing for learning. So far
                        it’s going quite well.
                    </p>
                    <p>
                        I’m bullish on people who genuinely care about the work they do and the impact it has on
                        people, and it shows in the work they put out. Great engineering talent must be backed by
                        great engineering integrity.
                    </p>
                </div>
            </div>
        </section>
    );
}
